import type {
  YachtDice,
  YachtDie,
  YachtDieValue,
  YachtScoringDice,
} from "../types";

export function isDieValue(value: unknown): value is YachtDieValue {
  return (
    value === 1 ||
    value === 2 ||
    value === 3 ||
    value === 4 ||
    value === 5 ||
    value === 6
  );
}

export function isValidDieIndex(index: number): boolean {
  return Number.isInteger(index) && index >= 0 && index < 5;
}

export function isCompleteDice(
  dice: readonly YachtDie[],
): dice is YachtScoringDice {
  return dice.length === 5 && dice.every(isDieValue);
}

export function toScoringDice(dice: YachtDice): YachtScoringDice | null {
  return isCompleteDice(dice) ? dice : null;
}

export function replaceDie(
  dice: YachtDice,
  index: number,
  value: YachtDieValue,
): YachtDice {
  return dice.map((die, dieIndex) =>
    dieIndex === index ? value : die,
  ) as unknown as YachtDice;
}

export function replaceHeld(
  held: readonly boolean[],
  index: number,
  value: boolean,
): readonly [boolean, boolean, boolean, boolean, boolean] {
  return held.map((current, heldIndex) =>
    heldIndex === index ? value : current,
  ) as unknown as readonly [boolean, boolean, boolean, boolean, boolean];
}
